import { createContext, useContext, useMemo, useState } from "react";
import { getSidebarConfig, mainSidebarConfig } from "./data";
import { getStoredAccountType } from "@/modules/safecheck/auth";

const SidebarConfigContext = createContext<MainSidebarConfig>(mainSidebarConfig);

export function useSidebarConfig() {
  return useContext(SidebarConfigContext);
}

export function SidebarConfigProvider({ children }: { children: React.ReactNode }) {
  const [accountType] = useState(() => getStoredAccountType());
  const config = useMemo(() => getSidebarConfig(accountType), [accountType]);

  return (
    <SidebarConfigContext.Provider value={config}>{children}</SidebarConfigContext.Provider>
  );
}
